<div *ngIf="isEditing; else lessorsPreview">
  <div>
    <label for="binary" class="checkbox-label">Is Default</label>
    <p-checkbox
      [(ngModel)]="isDefaultLessor"
      binary="true"
      inputId="binary"
      (onChange)="isDefaultLessorChange.emit(isDefaultLessor)"
                id="isDriverLessor"
    ></p-checkbox>
  </div>
  <p-multiSelect
    *ngIf="!isDefaultLessor"
    aria-label="lessorSelector"
    [filter]="true"
    [options]="lessors"
    [(ngModel)]="selectedLessors"
    optionLabel="lessorId"
    filterBy="lessorId"
    [style]="{ minWidth: '100%', marginTop: '5px' }"
    (onPanelShow)="sortSelected()"
    (onChange)="selectedLessorsChange.emit(selectedLessors)"
    tabbableMultiselect
  ></p-multiSelect>
</div>
<ng-template #lessorsPreview>
  <div>
    {{ selectedLessors.length }} lessors selected
  </div>
</ng-template>
